"use client";

import {
  HeroSection,
  PersonasSection,
  StatsSection,
  TestimonialsSection,
} from "@/components/sections/home";

import PostTestimonialSection from "@/components/sections/home/PostTestimonialSection";

/**
 * Composes the marketing homepage sections.
 * Copy lives in locale home.json files (Blob + static fallback via getMessages).
 */
export default function HomePage() {
  return (
    <>
      <HeroSection />
      <PersonasSection />
      <StatsSection />
      <TestimonialsSection />
      <PostTestimonialSection />
    </>
  );
}
